(function ($) {
  Drupal.behaviors.productFullSizeToggleV1 = {
    attach: function (context) {
      $('.js-button-toggle', context).once('productFullSizeToggleV1').each(function () {
        const $group = $(this);

        $group.find('.js-size-toggle-wrapper').on('click', function (e) {
          e.preventDefault();

          const $clicked = $(this);
          const isAlreadySelected = $clicked.hasClass('selected');
          const href = $clicked.attr('href');

          if (!href || isAlreadySelected) {
            return;
          }

          $group.find('.js-size-toggle-wrapper').removeClass('selected');
          $clicked.addClass('selected');

          setTimeout(() => {
            window.location.href = href;
          }, 10);
        });
      });
    }
  };
})(jQuery);
